/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SerialNumber
 */
export interface SerialNumber {
    /**
     * Eindeutige ID der Seriennummer
     * @type {string}
     * @memberof SerialNumber
     */
    id: string;
    /**
     * Die eigentliche Seriennummer
     * @type {string}
     * @memberof SerialNumber
     */
    number: string;
}

/**
 * Check if a given object implements the SerialNumber interface.
 */
export function instanceOfSerialNumber(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "number" in value;

    return isInstance;
}

export function SerialNumberFromJSON(json: any): SerialNumber {
    return SerialNumberFromJSONTyped(json, false);
}

export function SerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): SerialNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
    };
}

export function SerialNumberToJSON(value?: SerialNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'number': value.number,
    };
}

